// 成功案例
<template>
  <div class="main">
    <div class="head">
      <myheadert></myheadert>
      <img src="~@/assets/aboutMe_img/u6086-4.png" class="title">
    </div>
    <div class="middle">
      <div class="location">
        <img src="~@/assets/common_img/house.png">
        <span class="place">您的位置：&nbsp;<span @click="goHome">主页</span>＞商用解决方案＞企业业绩</span>
      </div>
      <div class="lead">
        <ul>
          <li class="lead_first"><a href="#/work">企业业绩</a></li>
          <li><a href="#/success">成功案例</a></li>
        </ul>
      </div>
      <div class="line"></div>
    </div>
    <div class="work">
      <div class="left">
        <ul>
          <li><p>太原铁路局七个车务段40个车站广播系统中铁六局物资商城</p></li>
          <li><p>中铁六局物资商城</p></li>
          <li><p>北京丰台城建锅炉监测系统</p></li>
          <li><p>中铁物贸招评标工作场所建设</p></li>
          <li><p>中铁物贸机房建设</p></li>
          <li><p>中铁国际集团视频会议系统</p></li>
          <li><p>云南三个采石场视频监控与设备监控系统</p></li>
          <li><p>双百公司生产销售管理系统</p></li>
          <li><p>物业管理信息系统</p></li>
          <li><p>中移铁通视频监控设备及安装</p></li>
          <li><p>角门供热厂锅炉低氮改造计算机管理监控系统平台开发技术服务</p></li>
          <li><p>角门供热厂视频监控系统工程</p></li>
        </ul>
      </div>
      <div class="right">
        <ul>
          <li>望园供热厂锅炉低氮改造计算机管理监控系统平台开发技术服务</li>
          <li>望园供热厂视频监控系统工程</li>
          <li>望园大厦安防系统及消防监控改造工程</li>
          <li>丰开科技孵化器消防监控改造工程</li>
          <li>望园东里地下车库监控系统工程</li>
          <li>望园大厦安防系统改造</li>
          <li>国家体育总局武术运动管理中心安防系统</li>
          <li>望园大厦保密室增加监控安防系统工程</li>
          <li>丰台区望园西里物业监控系统技术服务</li>
          <li>望园大厦门禁设备工程</li>
          <li>北京德佳物业管理有限公司停车场监控系统</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goHome () {
      this.$router.push(
        {
          path: '/'
        }
      )
      location.reload()
    }
  }
}
</script>
<style>
@media screen and (min-width: 1500px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/project_img/01835-crop-u6721.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 900px;
  margin-top: 25px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: 1%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 12%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_first{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 成功案例 */
.work ul{
  list-style: none;
  font-size: 14px;
  font-family: "宋体";
  padding-bottom: 50px;
}
.work .left{
  float: left;
}
.work .right{
  float: right;
}
.work .left{
  margin-left: 14.5%;
  margin-top: 20px;
}
.work .right{
  margin-right: 25%;
  margin-top: 20px;
}
.work ul li{
margin-top: 10px;
}
}
@media screen and (min-width: 1200px) and (max-width:1499px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/project_img/01835-crop-u6721.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 750px;
  margin-top: 20px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -3%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 15%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_first{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 成功案例 */
.work ul{
  list-style: none;
  font-size: 16px;
  font-family: "宋体";
  margin-left: 20%;
  padding-bottom: 50px;
}
.work ul li{
margin-top: 10px;
}
}
@media screen and (min-width: 960px) and (max-width:1199px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/project_img/01835-crop-u6721.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 600px;
  /* margin-left: 20px; */
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -6%;
  margin-left: 14.5%;
  font-size: 16px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_first{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 成功案例 */
.work ul{
  list-style: none;
  font-size: 16px;
  font-family: "宋体";
  margin-left: 20%;
  padding-bottom: 50px;
}
.work ul li{
margin-top: 10px;
}
}
@media screen and (min-width: 768px) and (max-width:959px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/project_img/01835-crop-u6721.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 400px;
  /* margin-left: 30px; */
  /* margin-top: 10px; */
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -11%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 20px;
  float: left;
  text-align: center;
  line-height: 20px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_first{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 20px;
}
/* 成功案例 */
.work ul{
  list-style: none;
  font-size: 16px;
  font-family: "宋体";
  margin-left: 20%;
  padding-bottom: 50px;
}
.work ul li{
margin-top: 10px;
}
}
@media screen and (min-width: 702px) and (max-width:767px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/project_img/01835-crop-u6721.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 500px;
  margin-left: 50px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -12%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 20px;
  float: left;
  text-align: center;
  line-height: 20px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_first{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 20px;
}
/* 成功案例 */
.work ul{
  list-style: none;
  font-size: 16px;
  font-family: "宋体";
  margin-left: 20%;
  padding-bottom: 50px;
}
.work ul li{
margin-top: 10px;
}
}
@media screen and (max-width:701px){
  .main{
    width: 100%;
    height: auto;
  }
      /* 顶部 */
.head{
  width: 100%;
  height: auto;
  background-image: url('~@/assets/project_img/01835-crop-u6721.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.title{
  width: 50%;
  margin-left: 30%;
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  margin-top: 10px;
  margin-left: 10%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 6%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
/* .lead{
  margin-left: 61%;
  margin-bottom: 0;
} */
.lead ul{
  list-style: none;
  margin-top: 20px;
  margin-left: 30%;
}
.lead ul li{
  width: 25%;
  height: 14px;
  float: left;
  text-align: center;
  line-height: 12px;
  /* margin-left: 10px; */
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_first{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 34px;
}
/* 成功案例 */
.work ul{
  list-style: none;
  font-size: 0.5rem;
  font-family: "宋体";
  margin-left: 20%;
  padding-bottom: 50px;
}
.work ul li{
margin-top: 10px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/project/work.vue